import { render, staticRenderFns } from "./ProjectsApproved.vue?vue&type=template&id=0fc39cc3&scoped=true&"
import script from "./ProjectsApproved.vue?vue&type=script&lang=js&"
export * from "./ProjectsApproved.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsApproved.vue?vue&type=style&index=0&id=0fc39cc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc39cc3",
  null
  
)

export default component.exports